/**
 * `Card` — superficie contenitore riusabile.
 *
 * `interactive` abilita l'effetto hover (elevazione). L'elemento resta un
 * contenitore neutro: passare eventuali `aria-*` via props quando serve.
 */
import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
  children: ReactNode;
}

export function Card({ interactive = false, className, children, ...rest }: CardProps) {
  const classes = [
    'ui-card',
    interactive ? 'ui-card--interactive' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
